const NavBar = () => {
  return (
    <nav className="">
      <br /><br />
      <div className="back text-light">
        <p className="display-4 "> Weather prediction project</p>
        
         
            <h2>Welcome home!</h2>
            
            <h6>
              This's an app to know how is the weather in the city what you
              want. It's so easy to use, just put the city in a white panel and
              press "Search"{" "}
            </h6>
            <br />
         
        
      </div>
    </nav>
  );
};

export default NavBar;
